import * as React from 'react';
import { observer } from 'mobx-react';
import './payText.scss';

interface IPayTextProps {
    payText: string;
    annualPayText: string;
    isHourly: boolean;
    className?: string;
    payTypeClassName?: string;
}

export class PayText extends React.Component<IPayTextProps> {
    render(): React.ReactNode {
        const className = this.props.className ? this.props.className : '';
        const payTypeClassName = this.props.payTypeClassName ? `pay-text--${this.props.payTypeClassName}` : '';
        return (
            <div className={payTypeClassName}>
                <div
                    data-mf-replace-inner="***"
                    className={`pay-text__pay ${className}`}
                >
                    {this.getPayText()}
                </div>
                <div
                    data-mf-replace-inner="***"
                    hidden={this.props.isHourly === false}
                    className="pay-text__annual"
                >
                    {this.props.annualPayText}
                </div>
            </div>
        );
    }

    private getPayText(): string {
        const perHour = this.props.isHourly ? '/hour' : '';
        return `${this.props.payText}${perHour}`;
    }
}

export default observer(PayText);